module.exports = __webpack_public_path__ + "static/media/covid-act-now-logo.0ac0983b.png";